/* components/Tab.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	text
} from "svelte/internal";

import { route } from "~/stores/router";

function add_css() {
	var style = element("style");
	style.id = "svelte-1czzk7o-style";
	style.textContent = "span.svelte-1czzk7o{user-select:none;cursor:pointer}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let span;
	let t;
	let span_aria_current_value;
	let dispose;

	return {
		c() {
			span = element("span");
			t = text(/*name*/ ctx[0]);
			attr(span, "class", "tabnav-tab svelte-1czzk7o");
			attr(span, "aria-current", span_aria_current_value = /*$route*/ ctx[2] === /*tabRoute*/ ctx[1] && "page" || undefined);
		},
		m(target, anchor, remount) {
			insert(target, span, anchor);
			append(span, t);
			if (remount) dispose();
			dispose = listen(span, "click", /*click_handler*/ ctx[3]);
		},
		p(ctx, [dirty]) {
			if (dirty & /*name*/ 1) set_data(t, /*name*/ ctx[0]);

			if (dirty & /*$route, tabRoute*/ 6 && span_aria_current_value !== (span_aria_current_value = /*$route*/ ctx[2] === /*tabRoute*/ ctx[1] && "page" || undefined)) {
				attr(span, "aria-current", span_aria_current_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(span);
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $route;
	component_subscribe($$self, route, $$value => $$invalidate(2, $route = $$value));
	let { name } = $$props;
	let { tabRoute } = $$props;
	const click_handler = () => route.set(tabRoute);

	$$self.$set = $$props => {
		if ("name" in $$props) $$invalidate(0, name = $$props.name);
		if ("tabRoute" in $$props) $$invalidate(1, tabRoute = $$props.tabRoute);
	};

	return [name, tabRoute, $route, click_handler];
}

class Tab extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1czzk7o-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { name: 0, tabRoute: 1 });
	}
}

export default Tab;